const HouseAtPoohCorner = [
	'Christopher Robin and I walked along',
	'Under branches lit up by the moon',
	'Posing our questions to Owl and Eeyore',
	'As our days disappeared all too soon',
	"But I've wandered much further today than I should",
	"And I can't seem to find my way back to the wood",
	'',
	"So help me if you can, I've got to get",
	'Back to the house at Pooh corner by one',
	"You'd be surprised there's so much to be done",
	'Count all the bees in the hive',
	'Chase all the clouds from the sky (chase the clouds from above)',
	'Back to the days of Christopher Robin and Pooh',
	'',
	"Winnie the Pooh doesn't know what to do",
	'Got a honey jar stuck on his nose',
	'He came to me asking help and advice',
	'And from there no one knows where he goes',
	"So I sent him to ask of the owl if he's there",
	'How to loosen a jar from the nose of a bear',
	'',
	"So help me if you can I've got to get",
	'Back to the house at Pooh corner by one',
	"You'd be surprised there's so much to be done",
	'Count all the bees in the hive',
	'Chase all the clouds from the sky (chase the clouds from above)',
	'Back to the days of Christopher Robin and Pooh',
	'',
	'Back to the days of Christopher Robin (back to days)',
	'Back to the ways of Christopher Robin (back to the ways)',
	'Back to the days of Pooh',
];

export default HouseAtPoohCorner;
